import { useLayoutEffect, useRef } from 'react';

type Props = {
  html?: string;
  onlyText?: boolean;
};

export const ShadowRoot = ({ html, onlyText }: Props) => {
  const hostRef = useRef<HTMLDivElement>(null);
  const shadowRef = useRef<ShadowRoot | null>(null);
  const containerRef = useRef<HTMLDivElement | null>(null);

  useLayoutEffect(() => {
    if (!hostRef.current) return;

    if (!shadowRef.current) {
      shadowRef.current = hostRef.current.attachShadow({ mode: 'open' });

      containerRef.current = document.createElement('div');
      shadowRef.current.appendChild(containerRef.current);
    }

    if (!containerRef.current) {
      return;
    }

    if (onlyText) {
      const element = document.createElement('div');
      element.innerHTML = html || '';
      containerRef.current.textContent = element.textContent || '';
      return;
    }

    containerRef.current.innerHTML = html || '';
  }, [html, onlyText]);

  return <div ref={hostRef} />;
};
